










































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { GrantResource, Grant } from '@/api/grant';
import { Account } from '@/api/consumeraccountdetails';
import TunesGrantsSheet from '@/components/account/TunesGrantsSheet.vue';

interface TableItem {
  totalGrants: number,
  remainingTotal: number
}

@Component({
  computed: mapState(['fiId']),
  components: {
    TunesGrantsSheet,
  },
})
export default class TunesGrantsTable extends Vue {
  @Prop() account!: Account;

  @Prop() relationship!: string;

  fiId!: string;

  loading: boolean = true;

  headers: DataTableHeader[] = [
    {
      text: 'Total Outstanding Grants',
      value: 'grants.length',
    },
    {
      text: 'Total Outstanding Grants Amount Remaining',
      value: 'remainingTotal',
    },
  ];


  showTunesGrantsSheet: boolean = false;

  grants: Grant[] = [];

  tableItems: TableItem[] = [];

  @Inject('GrantResource')
  grantResource!: GrantResource;

  mounted() {
    this.loadDetails();
  }

  @Watch('account')
  async loadDetails() {
    this.loading = true;
    this.grants = [];
    this.tableItems = [];

    if (this.fiId && this.account) {
      this.grantResource.getOutstandingGrantsByAccount(this.fiId, this.account.accountKasasaKey)
        .then((results: Grant[]) => {
          this.grants = results;

          let total: number = 0;
          this.grants.forEach((grant: Grant) => {
            total += grant.amountRemaining;
          });
          this.tableItems.push({
            totalGrants: results.length,
            remainingTotal: total,
          });
        }).catch((error: any) => {
          this.showErrorMessage(error);
        }).finally(() => {
          this.loading = false;
        });
    }
  }

  showGrants() {
    this.showTunesGrantsSheet = true;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
